<template>

    <div class="p-compare-reserve__claim-table">
        <div class="p-compare-reserve__claim-table">
            <div class="a-table--short-no-style">
                <table class="a-table a-table--full-width">
                    <thead>
                    <tr>
                        <th rowspan="2" valign="top"><h2>Total Claims</h2></th>
                        <th colspan="2" valign="top"><h2>Under Set Limit</h2></th>
                        <th colspan="2" valign="top"><h2>Within Set Limit</h2></th>
                        <th colspan="2" valign="top"><h2>Above Set Limit</h2></th>
                    </tr>
                    <tr>
                        <th valign="top"><h2>Total</h2></th>
                        <th valign="top"><h2>%</h2></th>
                        <th valign="top"><h2>Total</h2></th>
                        <th valign="top"><h2>%</h2></th>
                        <th valign="top"><h2>Total</h2></th>
                        <th valign="top"><h2>%</h2></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>{{total}}</td>
                        <td>{{underLimit.total}}</td>
                        <td>{{roundValue(underLimit.percent * 100, 2)}}%</td>
                        <td>{{withinLimit.total}}</td>
                        <td>{{roundValue(withinLimit.percent * 100, 2)}}%</td>
                        <td>{{overLimit.total}}</td>
                        <td>{{roundValue(overLimit.percent * 100, 2)}}%</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import roundValue from 'mixins/roundValue';

    export default {
        name: "results-table",
        mixins:[
            roundValue
        ],
        computed: {
            ...mapGetters('reserves/compare', ['claims', 'from', 'to', 'range']),
            total() {
                return this.cleanClaims.length;
            },
            cleanClaims() {
                return this.claims.filter(claim => claim.percent !== Infinity && !isNaN(claim.percent));
            },
            underLimit() {
                let totalUnder = this.cleanClaims
                    .reduce((total, claim) => claim.percent < this.range[0] ? ++total : total, 0);
                return {
                    total: totalUnder,
                    percent: totalUnder / this.total
                };
            },
            overLimit() {
                let totalOver = this.cleanClaims
                    .reduce((total, claim) => claim.percent > this.range[1] ? ++total : total, 0);
                return {
                    total: totalOver,
                    percent: totalOver / this.total
                };
            },
            withinLimit() {
                let total = this.total - this.underLimit.total - this.overLimit.total;
                return {
                    total,
                    percent: total / this.total
                };
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// ResultsTable.vue?471a4fc5